import type { ResumeReviewForm } from "./personalization.types";

export const CANDIDATE_PROFILE_ROUTE = "profile";
export const CANDIDATE_IDENTITY_CONFLICT_CODE = "CANDIDATE_IDENTITY_CONFLICT";
export const PROFILE_HEADER_EMOJI_PATTERN = /[\p{Extended_Pictographic}\p{Emoji_Presentation}\uFE0F\u200D]/gu;
export const CANDIDATE_PROFILE_DRAFT_STORAGE_PREFIXES = {
  jobs_page: "candidate-profile-draft:",
  talent_network: "talent-network-profile-draft:",
} as const;

export const RESUME_WORK_MODES = ["remote", "hybrid", "onsite"] as const;
export const RESUME_NO_WORK_MODE = "no_preference";
export const RESUME_REVIEW_FIELDS = [
  ["name", true],
  ["email", true],
  ["phone", false],
  ["titles", true],
  ["skills", true],
  ["experienceYears", false],
  ["educationLevel", false],
  ["educationField", false],
  ["educationInstitution", false],
  ["workMode", false],
] as const;

export const EMPTY_REVIEW_FORM: ResumeReviewForm = {
  name: "",
  email: "",
  phone: "",
  titles: "",
  skills: "",
  keywords: "",
  experienceYears: "",
  educationLevel: "",
  educationField: "",
  educationInstitution: "",
  city: "",
  state: "",
  country: "",
  workMode: "",
};

export const PERSONALIZATION_FIELD_CLASS_NAME =
  "h-11 w-full rounded-[10px] border border-black bg-white px-3 text-sm text-[#101828] outline-none focus:ring-2 focus:ring-[#F8D96B]";
export const PERSONALIZATION_FIELD_LABEL_CLASS_NAME =
  "block text-sm font-semibold text-[#344054]";
export const PERSONALIZATION_PRIMARY_ACTION_CLASS_NAME =
  "h-12 w-full rounded-[10px] bg-primary font-bold text-primary-foreground";
export const PERSONALIZATION_RESEND_ACTION_CLASS_NAME =
  "w-full text-center text-sm font-semibold underline disabled:cursor-not-allowed disabled:opacity-50";
export const PERSONALIZATION_SHEET_CLASS_NAME = "bg-[#FFF8E8] px-5 pb-7 pt-3";
export const PERSONALIZATION_SHEET_CONTENT_CLASS_NAME = "z-[70]";
export const PERSONALIZATION_SHEET_OVERLAY_CLASS_NAME = "z-[69]";
export const TALENT_NETWORK_UPLOAD_COPY = {
  subtitle: "Upload your resume and get discovered by employers looking for talent like you.",
  consent: "I agree to artha.link's Terms of Service and Privacy Policy.",
  cta: "Join now",
  signIn: "Already have an account? Sign In",
  parsingTitle: (creatorName: string) =>
    `You\u2019re one step closer to joining ${creatorName}\u2019s network`,
  parsingMessage: "Getting your profile ready\u2026",
  parsingDescription: "We\u2019re turning your resume into a profile employers can discover.",
  termsUrl: "https://artha.link/terms-and-conditions/",
  privacyUrl: "https://artha.link/privacy-policy/",
} as const;

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isResumePersonalizationUiEnabled =
  process.env.NEXT_PUBLIC_RESUME_PERSONALIZATION_ENABLED === "true";

export const isAppcastResumeEligibilityEnabled =
  process.env.NEXT_PUBLIC_APPCAST_RESUME_ELIGIBILITY_ENABLED === "true";
